import styled from 'styled-components';

export const InfoStyled = styled.div`
  margin-top: 1rem;
  margin-bottom: 1rem;
  padding: 0 ${props => props.theme.size.rap};

  h1 {
    margin: 0;
  }

  span {
    color: ${props => props.theme.color.primary};
  }
`;
